import React from "react";
import Heading from "../ui/Heading";
import Slider from "react-slick";
import { Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import solitaire from '../../../../../Assets/nokaoi-imges/ring-style/solitaire.jpg'
import vintage from '../../../../../Assets/nokaoi-imges/ring-style/vintage.jpg'
import halo from '../../../../../Assets/nokaoi-imges/ring-style/halo.jpg'
import singleRow from '../../../../../Assets/nokaoi-imges/ring-style/single-row.jpg'
import goldengring from '../../../../../Assets/nokaoi-imges/ring-style/gold-eng-ring.jpg'
import goldsingleRrow from '../../../../../Assets/nokaoi-imges/ring-style/gold-single-row.jpg'
import leftArrow from '../../../../../Assets/nokaoi-imges/left-arrow.png'
import rightArrow from '../../../../../Assets/nokaoi-imges/right-arrow.png'
import { ar, tr } from "date-fns/locale";
const ShopRingByStyle = () => {
  const ringStyles = [
    {
      title: "14k White Gold Solitaire Round Engagement Ring",
      price: "$1,746",
      image: solitaire,
      url: "/engagement-rings/style=Solitaire",
    },
    {
      title: "14k White Gold Vintage Engagement Ring",
      price: "$4,666",
      image: vintage,
      url: "/engagement-rings/style=Vintage",
    },
    {
      title: "14k White Gold Halo Engagement Ring",
      price: "$4,611",
      image: halo,
      url: "/engagement-rings/style=Halo",
    },
    {
      title: "14k White Gold Single Row Engagement Ring",
      price: "$2,346",
      image: singleRow, // or goldsingleRrow — depending on what you're displaying
      url: "/engagement-rings/style=Single%20Row",
    },
    // {
    //   title: "14k White Gold Single Row Engagement Ring",
    //   price: "$2,346",
    //   image: singleRow, // or goldsingleRrow — depending on what you're displaying
    //   url: "/ringsettings/style=Single%20Row",
    // },
  ];

  // let settings2 = {
  //    accessibility: true,
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   arrows: true,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   prevArrow: <Image src={leftArrow} alt="arrow" />,
  //   nextArrow: <Image src={rightArrow} alt="arrow" />,
  //   responsive: [
  //     { breakpoint: 1479, settings: { slidesToShow: 4, dots: true, arrows: true } },
  //     { breakpoint: 1025, settings: { slidesToShow: 2, dots: true, arrows: true } },
  //     { breakpoint: 600, settings: { slidesToShow: 1, dots: true, arrows: true } },
  //   ],
  // };
  const settings2 = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    prevArrow: <Image src={leftArrow} alt="arrow"  className="img-fluid"/>,
    nextArrow: <Image src={rightArrow} alt="arrow"  className="img-fluid" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="shop-ring-by-style section-space">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Best Selling Products</h2>
        </Heading>

        <Slider {...settings2}>
          {ringStyles.map((ring, index) => (
            <div className="item_outer">

            <div className="item text-center" key={index}>
              <div className="position-relative">
<div className="whishlist_box">
                <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1_256)"><circle cx="43" cy="43" r="23" fill="white"></circle></g><path d="M53.1494 34.8506C52.5629 34.2639 51.8667 33.7985 51.1003 33.481C50.334 33.1634 49.5126 33 48.6831 33C47.8535 33 47.0321 33.1634 46.2658 33.481C45.4994 33.7985 44.8032 34.2639 44.2167 34.8506L42.9997 36.0677L41.7826 34.8506C40.5981 33.6661 38.9915 33.0006 37.3163 33.0006C35.6411 33.0006 34.0346 33.6661 32.85 34.8506C31.6655 36.0352 31 37.6417 31 39.3169C31 40.9921 31.6655 42.5987 32.85 43.7833L34.0671 45.0003L42.9997 53.9329L51.9323 45.0003L53.1494 43.7833C53.7361 43.1968 54.2015 42.5006 54.519 41.7342C54.8366 40.9679 55 40.1465 55 39.3169C55 38.4874 54.8366 37.666 54.519 36.8997C54.2015 36.1333 53.7361 35.4371 53.1494 34.8506V34.8506Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><defs><filter id="filter0_d_1_256" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset></feOffset><feGaussianBlur stdDeviation="10"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_256"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_256" result="shape"></feBlend></filter></defs></svg>
                {/* <svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1_259)"><circle cx="43" cy="43" r="23" fill="currentColor"></circle></g><path d="M37.2813 32.0106C35.347 31.9071 33.4069 32.5587 31.9789 33.9959C29.1212 36.878 29.4201 41.7147 32.4778 44.796L33.4545 45.7791L42.3305 54.7204C42.5089 54.8995 42.7506 55 43.0026 55C43.2545 55 43.4962 54.8995 43.6747 54.7204L52.5469 45.7791L53.5236 44.796C56.5812 41.7147 56.8782 36.878 54.0186 33.9978C51.1608 31.1176 46.3649 31.4242 43.3091 34.5037L43.0007 34.8141L42.6922 34.5037C41.1634 32.9611 39.2176 32.1141 37.2813 32.0106Z" fill="white"></path><defs><filter id="filter0_d_1_259" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset></feOffset><feGaussianBlur stdDeviation="10"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_259"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_259" result="shape"></feBlend></filter></defs></svg> */}
              </div>
              <Link to={ring.url} className="w-100">
                <Image src={ring.image} alt={`${ring.name} Ring`} />
              </Link>
              </div>
              
              <Link to={ring.url}>
                {ring.title}
              </Link>
              <h6>{ring.price}</h6>
            </div>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default ShopRingByStyle;
